import { createContext, useState, useEffect } from 'react';

// Crear el contexto
export const CategoriasContext = createContext();

const CategoriasProvider = ({ children }) => {
  // Estado que manejará el árbol de categorías seleccionado
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState(() => {
    // Obtener datos de localStorage o usar un array vacío por defecto
    const categoriasGuardadas = localStorage.getItem('categoriasSeleccionadas');
    return categoriasGuardadas ? JSON.parse(categoriasGuardadas) : [];
  });
  
  const [subcategorias, setSubCategorias] = useState(() => {
    const subcategoriasGuardadas = localStorage.getItem('subcategorias');
    return subcategoriasGuardadas ? JSON.parse(subcategoriasGuardadas) : [];
  });
  
  const [tercerasCategorias, setTercerasCategorias] = useState(() => {
    const tercerasCategoriasGuardadas = localStorage.getItem('tercerasCategorias');
    return tercerasCategoriasGuardadas ? JSON.parse(tercerasCategoriasGuardadas) : [];
  });

  // Función para actualizar las categorías seleccionadas y guardarlas en localStorage
  const actualizarCategorias = (nuevaCategoria) => {
    setCategoriasSeleccionadas(nuevaCategoria);
    localStorage.setItem('categoriasSeleccionadas', JSON.stringify(nuevaCategoria));
  };

  // Función para actualizar las subcategorías y guardarlas en localStorage
  const actualizarSubCategorias = (subcategorias) => {
    setSubCategorias(subcategorias);
    localStorage.setItem('subcategorias', JSON.stringify(subcategorias));
  };

  // Función para actualizar las terceras categorías y guardarlas en localStorage
  const actualizarTercerasCategorias = (tercerasCategorias) => {
    setTercerasCategorias(tercerasCategorias);
    localStorage.setItem('tercerasCategorias', JSON.stringify(tercerasCategorias));
  };

  // Usar useEffect para asegurarse de que el estado se guarde al actualizar
  useEffect(() => {
    // Se puede usar el useEffect si es necesario hacer algo extra al cargar el contexto
  }, [categoriasSeleccionadas, subcategorias, tercerasCategorias]);

  return (
    <CategoriasContext.Provider value={{ categoriasSeleccionadas, actualizarCategorias, subcategorias, actualizarSubCategorias, actualizarTercerasCategorias, tercerasCategorias }}>
      {children}
    </CategoriasContext.Provider>
  );
};

export default CategoriasProvider;
